var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup10000085571(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 10.3485L7.23743 10.332",
    stroke: "#02293D",
    strokeWidth: 0.910569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 10.3485L13.4562 10.332",
    stroke: "#02293D",
    strokeWidth: 0.910569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 16.5711L7.23743 16.5547",
    stroke: "#02293D",
    strokeWidth: 0.910569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 16.5711L13.4562 16.5547",
    stroke: "#02293D",
    strokeWidth: 0.910569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 22.7899L7.23743 22.7734",
    stroke: "#02293D",
    strokeWidth: 0.910569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 22.7899L13.4562 22.7734",
    stroke: "#02293D",
    strokeWidth: 0.910569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.7852,
    y: 10.2148,
    width: 9.21519,
    height: 18.4304,
    fill: "#F6901F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 29H1.37333C1.16715 29 1 28.8329 1 28.6267V4.48444C1 4.27824 1.16715 4.11111 1.37333 4.11111H10.3333V1.37333C10.3333 1.16715 10.5005 1 10.7067 1H19.2933C19.4995 1 19.6667 1.16715 19.6667 1.37333V10.3333M19.6667 29H28.6267C28.8329 29 29 28.8329 29 28.6267V10.7067C29 10.5005 28.8329 10.3333 28.6267 10.3333H19.6667M19.6667 29V22.7778M19.6667 10.3333V16.5556M19.6667 22.7778V16.5556M19.6667 22.7778H22.7778M19.6667 16.5556H22.7778",
    stroke: "#02293D",
    strokeWidth: 0.910569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10000085571);
export default __webpack_public_path__ + "static/media/Group 1000008557 (1).5bf61cff28ce82ef07b247adce3e62b0.svg";
export { ForwardRef as ReactComponent };